export enum UserType {
  CLIENT,
  SALES,
  TRADER,
  ADMIN,
  CLIENT_TRADER,
}

export namespace UserType {
  let elements = [
    UserType.CLIENT,
    UserType.SALES,
    UserType.TRADER,
    UserType.ADMIN,
    UserType.CLIENT_TRADER,
  ];
  let alias = "com.bcdfx.model.UserType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
